import { useMutation } from '@tanstack/react-query';
import { SwitchInlineEditor } from 'components/inline_edit/ToggleInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { LocationsTableCellProps } from 'pages/Settings/Locations/LocationsTable';
import { updateLocation } from 'utils/location';

export function LocationOPCEnabledCell({ rowData, onChange }: LocationsTableCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const { showToast } = useNotificationContext();
    const { mutate: toggleOPC, isPending } = useMutation({
        meta: { name: 'update-location' },
        mutationFn: (isEnabled: boolean) =>
            updateLocation(rowData, { OpcEnabled: isEnabled }),

        onSuccess: () => {
            onChange();
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location OPC setting',
            }),
    });

    return (
        <SwitchInlineEditor
            value={rowData.Settings.OpcEnabled}
            onConfirm={(val) => toggleOPC(val ?? false)}
            isDisabled={isPending || !canEditLocationDetails}
            renderValue={(val) => (val ? 'Enabled' : 'Disabled')}
        />
    );
}
